export default {
  title: 'Vos choix ont été enregistrés avec succès.',
  information: 'Veuillez noter qu’un délai de 30 jours peut être nécessaire pour la mise à jour de vos préférences.',

};
